import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import { HeaderHat } from '../../primitives/HeaderBlock/HeaderBlock.styles'
import {
  OverlapWrapper,
  TextBlock,
  OverlapBottom,
  ImgWrapper,
  OverlapOuter,
} from './OverlapBlock.styles'

const OverlapBlock = ({
  full,
  head,
  sub,
  buttons,
  graphic,
  maxWidth,
  maxHeight,
  rightPad,
  imgMargin,
  bgColor,
  landing,
  noPad,
  bgPct,
  textMax,
  blockW,
  accent,
  buttonPos,
}) => (
  <OverlapOuter bgColor={bgColor} full={full} bgPct={bgPct}>
    <OverlapWrapper
      blockW={blockW}
      bgColor={bgColor}
      landing={landing}
      full={full}
    >
      <TextBlock
        textMax={textMax}
        full={full}
        rightPad={rightPad}
        noPad={noPad}
        landing={landing}
      >
        <HeaderHat accent={accent} />
        <h3>{head}</h3>
        {sub && <div className="paras">{sub}</div>}
        {buttons && (
          <OverlapBottom buttonPos={buttonPos}>{buttons}</OverlapBottom>
        )}
      </TextBlock>
      {graphic && (
        <ImgWrapper
          imgMargin={imgMargin}
          maxWidth={maxWidth}
          maxHeight={maxHeight}
        >
          <GatsbyImage image={graphic} alt="" />
        </ImgWrapper>
      )}
    </OverlapWrapper>
  </OverlapOuter>
)

export default OverlapBlock
